import { FormGroup } from '@angular/forms';

export function map_to_SingleResponseModel<T>(input: listResponseModel<T>, mapItemFn?: (item: T) => any): SingleResponseModel<ResponseModel<any>> {
  return {
    statuscode: input.statuscode,
    objecttype: "",
    message: input.message,
    success: input.success,
    result: {
      totalcount: input.result?.length ?? 0,
      items: input.result?.map(item => ({
        _entitydto: mapItemFn ? mapItemFn(item) : item,
        notesCount: 0,
        attachCount: 0,
        id: (item as any)?.id ?? null
      })) ?? []
    }
  };
}



export interface ExportOptions {
  value: string;
  viewValue: string;
}

export interface GridInfo {
  columnDef: string;
  header: string;
  cell: any;
  fieldType;
}

export interface ApiGridInfo {
  fieldname: string;
  displaylatname: string;
  displayaraname: string;
  fieldtype: string;
}

export interface IBaseService<T> {
  //fieldsConfigService;
  get();
  getById(id);
  add(input: T);
  update(id, input: T);
  delete(id);
  getDetails();
}

export interface FieldConfig {
  tenantid: any;
  tablename: string;
  fieldname: string;
  displayname: string;
  fieldtype: string;
  displaylist: boolean;
  filter: boolean;
  criteria: boolean;
  required: boolean;
  minval: number;
  maxval: number;
  defaultvalue: string;
  printable: boolean;
  infofield: boolean;
}

//region of cover object
export interface ResponseModel<T> {
  totalcount: number;
  items: T[];
}

export interface SingleResponseModel<T> {
  statuscode: number;
  objecttype: string;
  message: string;
  result: T;
  success: boolean;
}

export interface listResponseModel<T> {
  statuscode: number;
  objecttype: string;
  message: string;
  result: T[];
  // items: T[];
  success: boolean;
}

export interface gridResponseModel<T> {
  headers: ApiGridInfo[];
  items: T[];
  totalcount: number;
}

export interface searchSqlModel<T> {
  totalcount: number;
  message: string;
  data: T[];
  success: boolean;
}

export interface withCountResponseModel<T> {
  id: string;
  _entitydto: T;
  notesCount: number;
  attachCount: number
}
//end region

//from TAB Web
export class FieldDictionaryDto {
  readonly id?: string | undefined;
  fieldname?: string | undefined;
  displayaraname?: string | undefined;
  dislaylatname?: string | undefined;
  fieldtype?: string | undefined;
  menukey: string;
  parameter: string | null;
  fielddisplayon: number;
  filter?: boolean | undefined;
  required?: boolean | undefined;
  minvalue?: number | undefined;
  maxvalue?: number | undefined;
  defaultvalue?: string | undefined;
  searchsqlquery?: string | undefined;
  precision?: number;
  linkedform?: string | undefined;
  stopduplicate?: boolean | undefined;
  printable?: boolean | undefined;
  infofield?: boolean | undefined;
  tablename: string | undefined;
  langvalue: langValue[] | null;
  contacttype: string | null;
  sort: number;
  autoincrement: number;
  enable: boolean
}

export class langValue {
  culturename: string;
  value: string;
  id: string;
}

export interface showGridListDto {
  fieldname: string;
  fieldtype: string;
  sort: number;
  langvalue: [{ culuturename: string; culuturevalue: string }]
}

export class FieldDictionary {
  id?: string | undefined;
  menukey: string;
  parameter: string;
  fieldname?: string | undefined;
  displayaraname?: string | undefined;
  dislaylatname?: string | undefined;
  fieldtype?: string | undefined;
  fielddisplayon: number;
  filter?: boolean | undefined;
  required?: boolean | undefined;
  minvalue?: number | null;
  maxvalue?: number | null;
  defaultvalue?: string | undefined;
  precision?: number | null;
  printable?: boolean | undefined;
  infofield?: boolean | undefined;
  tablename: string | undefined;
  sort?: number | undefined;
  autoincrement?: boolean | undefined;
  enable: null;
  stopduplicate: boolean;
  contacttype: null
}

export class CommandDto {
  readonly id?: string | undefined;
  tabsystemmenuid?: string;
  identityuserid: string;
  type: number;
  commandname: string;
  functionname: string;
}

export class UserFavouritePageDto {
  readonly id?: string | undefined;
  tabsystemmenuid?: string;
  identityuserid?: string;
}

export class UserFavouritePageMenuDto {
  readonly id?: string | undefined;
  tabsystemmenuid?: string;
  identityuserid?: string;
  syscode: number;
  parentid?: string | undefined;
  menuaraname: string;
  menulatname: string;
  menudescription: string;
  pageurl: string;
  pageparameters: string;
  tabpertypecode: number;
  notactive: false;
}

export class TabSystemMenuDto {
  readonly id?: string | undefined;
  syscode: number;
  parentid?: string | undefined;
  menuaraname: string;
  menulatname: string;
  menudescription?: string;
  menukey: string;
  pageurl: string;
  pageparameters: string;
  relatedtables?: [];
  tabpermissiontypecode?: number;
  notactive?: false;
  menuicon?: null;
  level?: number;
  sort?: number;
  haveinsert?: boolean;
  haveedit?: boolean;
  haveaccess?: boolean;
  havedelete?: boolean;
  haveprint?: boolean;
  haveexport?: boolean;
  tablename?: boolean;
  criteria?: boolean
}

export class BaseNotesDto {
  readonly id?: string;
  menukey: string;
  recordid: string;
  note: string;
  pageparameters?: string;
}

export class baseAttachDto {
  readonly id?: string | undefined;
  tenantid?: string | undefined;
  relativepath: string;
  description: string;
  name: string;
  ext: string;
  stream: any;
  creationtime: Date | undefined;
  creatorid: string | undefined;
  lastmodifierid: string | undefined;
  lastmodificationtime: Date | undefined;
  deleterid: string | undefined;
  deletiontime: Date | undefined;
  isdeleted: boolean;
  filesize: number
}

export class reportDesignerDto {
  readonly id?: string | undefined;
  //tabsystemmenuid: string | undefined;
  menukey: string;
  pageparameters: string | undefined;
  reportaraname: string;
  reportlatname: string;
  reportfilename: string;
  active: boolean;
  defaultreport: boolean;
}

export interface LocalFormData {
  screen: string;
  showrestorebtn: boolean;
  formvalue: any;
  footerData?: any;
}

export class SessionData {
  userid: string;
  tenantid: string;
  accesstoken: string;
  branchid;
  payslibid;
}

export interface FormItem {
  form: FormGroup;
  hasImage?: boolean;

  // Synchronous hooks (required)
  beforesavework(): boolean;
  aftersavework(id): boolean;
  customvalidation(): string[];
  aftergetdatawork(data);
  beforedownloadtemplatework(): string[];

  // Async hooks (optional) - called by BaseEntry if present
  beforeSaveWork_async?(): Promise<boolean> | boolean;
  afterSaveWork_async?(id: string): Promise<void>;
  beforeUpdateWork_async?(): Promise<boolean> | boolean;
  afterUpdateWork_async?(id: string): Promise<void>;
  afterGetDataWork?(data: any): void;
}

// export interface userDto {
//   readonly id?: string | undefined;
//   tenantId: string | undefined;
//   userName: string;
//   name: string;
//   surname: string;
//   email: string;
//   emailConfirmed: boolean;
//   phoneNumber: string;
//   phoneNumberConfirmed: boolean;
//   isActive: boolean;
//   lockoutEnabled: boolean;
//   accessFailedCount: number;
//   lockoutEnd: Date | undefined;
//   concurrencyStamp: string;
//   entityVersion: number;
//   lastPasswordChangeTime: Date | undefined;
//   isDeleted: boolean;
//   deleterId: string;
//   deletionTime: Date | undefined;
//   lastModificationTime: Date | undefined;
//   lastModifierId: string;
//   creationTime: Date | undefined;
//   creatorId: string;
//   profilePicId: string | undefined;
//   profilePic: string | undefined;
//   passwordDuration: number;
//   empId: string | undefined;
//   empAraName: string | undefined;
//   empLatName: string | undefined;
//   notesCount: number;
//   attachCount: number;
// }

// export interface createUserDto {
//   readonly id: string;
//   readonly tabSystemMenuId: string;
//   readonly menuKey: string;
//   readonly pageParameters: string;
//   userName: string;
//   name: string;
//   surname: string;
//   email: string;
//   phoneNumber: string;
//   password: string;
//   description: string;
//   ProfilePic: FormData;
//   isActive: boolean;
// }

// export interface customUserDto {
//   userId: string;
//   userName: string;
//   name: string;
//   email: string;
// }
export interface userDto {
  readonly id?: string | undefined;
  tenantid: string | undefined;
  username: string;
  name: string;
  surname: string;
  email: string;
  emailconfirmed: boolean;
  phonenumber: string;
  phonenumberconfirmed: boolean;
  isactive: boolean;
  lockoutenabled: boolean;
  accessfailedcount: number;
  lockoutend: Date | undefined;
  concurrencystamp: string;
  entityversion: number;
  lastpasswordchangetime: Date | undefined;
  isdeleted: boolean;
  deleterid: string;
  deletiontime: Date | undefined;
  lastmodificationtime: Date | undefined;
  lastmodifierid: string;
  creationtime: Date | undefined;
  creatorid: string;
  profilepicid: string | undefined;
  profilepic: string | undefined;
  passwordduration: number;
  empid: string | undefined;
  emparaname: string | undefined;
  emplatname: string | undefined;
  notescount: number;
  attachcount: number;
}

export interface createUserDto {
  readonly id: string;
  // readonly tabsystemmenuid: string;
  // readonly menukey: string;
  // readonly pageparameters: string;
  username: string;
  name: string;
  surname: string;
  email: string;
  phonenumber: string;
  password: string;
  description: string;
  // profilepic: FormData;
  profilepic: string;
  isactive: boolean;
}

export interface customUserDto {
  userid: string;
  username: string;
  name: string;
  email: string;
}
export interface reportData {
  reportfilename;
  reportname;
}

export interface tabsSystems {
  code: number;
  sysaraname: string;
  syslatname: string;
  sysdescription: string;
  syslatdescription: string;
  icon: string;
  pageurl: string;
  notactive: boolean;
  dbname: string;
}
export interface VerificationSettingsDto {
  id?: string;
  table: string;
  actioncode: number;
  condition: string;
  message: string;
}
export interface CustomFunctionalityDto {
  id?: string;
  identityuserid?: string;
  menukey: string;
  pageparameters: string;
  type: string;
  commandname: string;
  functionname: string;
}
export interface AfterActionSettingsDto {
  id?: string;
  table: string;
  actioncode: number;
  todo: string;
}
export interface changePasswordDto {
  currentpassword: string;
  newpassword: string;
}

export interface pageFields {
  list: FieldDictionaryDto[];
  pageid: string;
}

export interface accountDto {
  id: string | undefined;
  creationtime: Date | undefined;
  creatorid: string | undefined;
  lastmodificationtime: Date | undefined;
  lastmodifierid: string | undefined;
  isdeleted: boolean;
  deleterid: string | undefined;
  deletiontime: Date | undefined;
  tenantid: string | undefined;
  username: string;
  name: string;
  surname: string;
  email: string;
  emailconfirmed: boolean;
  phonenumber: string;
  phonenumberconfirmed: boolean;
  isactive: boolean;
  lockoutenabled: boolean;
  accessfailedcount: number;
  lockoutend: Date | undefined;
  concurrencystamp: string;
  entityversion: number;
  lastpasswordchangetime: Date | undefined;
}

export interface userPaySlips {
  readonly id: string;
  identityuserid: string;
  payslipid: string;
  payslip: paySlipDto;
  defaultpayslip: boolean;
  notactive: boolean
}

export interface userInfo {
  userid: string | undefined;
  username: string;
  name: string;
  email: string;
  roleid: string;
  rolearaname: string;
  rolelatname: string;
  defaultbranchid: string;
  defaultbrancharaname: string;
  defaultbranchlatname: string;
  tenantid: string;
  pofileimage: string;
  companyaraname: string;
  companylatname: string;
}

export interface rolesDto {
  name: string;
  isdefault: boolean;
  isstatic: boolean;
  ispublic: boolean;
  id: string | undefined;
}

export interface exbandablePermissionItem {
  expandable: boolean;
  id: string | undefined;
  name: string;
  tabpermissiontypecode: number;
  level: number;
}
export interface permissionItem {
  menuid: string | undefined;
  name: string;
  tabpermissiontypecode: number;
  access: boolean;
  insert: boolean;
  edit: boolean;
  delete: boolean;
  print: boolean;
  export: boolean;
  notactive: boolean;
  children?: permission[];
}

export interface permission extends permissionItem {
  children?: permissionItem[];
}

export interface userPermissionsDto {
  syscode: number;
  sysaraname: string;
  syslatname: string;
  parentid: string | undefined;
  haveinsert: boolean;
  haveedit: boolean;
  haveaccess: boolean;
  havedelete: boolean;
  haveprint: boolean;
  haveexport: boolean;
  menuid: string | undefined;
  menuaraname: string;
  menulatname: string;
  tabpermissiontypecode: number;
  userid: string | undefined;
  access: boolean;
  insert: boolean;
  edit: boolean;
  delete: boolean;
  print: boolean;
  export: boolean;
  notactive: boolean;
}

export interface userPermissionsCreateDto {
  identityuserid: string;
  tabsystemmenuid: string;
  access: boolean;
  insert: boolean;
  edit: boolean;
  delete: boolean;
  print: boolean;
  export: boolean;
  notactive: boolean;
}

export interface IActualSystemMenuPermission {
  userid: string;
  username: string;
  userdepdescription: string;
  userjobdescription: string;
  tenantid: string;
  tabsystemmenuid: string;
  parentid: string;
  level: number;
  menuaraname: string;
  menulatname: string;
  access: boolean;
  insert: boolean;
  edit: boolean;
  delete: boolean;
  print: boolean;
  export: boolean;
}

export interface IActualSystemMenuPermissionList {
  list: IActualSystemMenuPermission[];
  menuid: string;
}

export interface searchSqlDto {
  fielddictionaryid: string;
  columnssearch: {};
  searchinallcolumns: string;
  searchoperator: number;
  skip: number;
  take: number;
  orderby: string;
  descending: boolean
}

export interface notificationCardDto {
  readonly id: string;
  icon: string;
  title: string;
  description: string;
  isread: boolean
}
export interface GeneralSettingGroupDto {
  id?: string;
  araname: string;
  latname: string;
  tenantid: string;
  notactive: boolean;
}

export interface GeneralSettingSideTypeDto {
  id?: string;
  syscode: number;
  sidetypearaname: string;
  sidetypelatname: string;
  notactive: boolean;
  tenantid: string;
  tablename: string;
  namefield_ar: string;
  namefield_en: string;
}

export interface GeneralSettingDto {
  id?: string;
  name: string;
  abb: string;
  fieldtypeid: string;
  groupid: string;
  defaultvalue: string;
  tenantid: string;
  description: string;
  notactive: boolean;
}

export interface GeneralSettingSideDto {
  id?: string;
  settingid: string;
  sidetypeid: string;
  sideid: string | null;
  tenantid: string;
  value: string;
  notactive: boolean;
}

// Example model for HR System - Pay Slip
export interface paySlipDto {
  id?: string;
  payslipcode: number;
  paysliparaname: string;
  paysliplatname: string;
  notactive: boolean;
}

// Example model for HR System - Pay Current Month
export interface PayCurrentMonthDto {
  id?: string;
  branchid: string;
  slipid: string;
  year: number;
  month: number;
  closed: boolean;
}
// Example model for HR System - Salary Elements
export interface PayElementsDto {
  id?: string;
  elementcode: number;
  elementaraname: string;
  elementlatname: string;
  elementnaturecode: number;
  elementunit: number;
  taxable: boolean;
  maxvalue: number;
  minvalue: number;
  installments: boolean;
  mathequation: string;
  notactive: boolean;
  notcomputed: boolean;
  eqsort: number;
  mandatoryforallemp: boolean;
  payelementsubelements?: PayElementSubElementDto[];
  elementtypecode: number;
  elementtype: PayElementTypeDto;
  elementnature: PayElementNatureDto;
  elementunitdata: ElementUnitDto
}

export interface PayElementSubElementDto {
  subelementaraname: string;
  subelementlatname: string;
  elementid: string;
}

export interface PayElementNatureDto {
  code: number;
  naturearaname: string;
  naturelatname: string;
  notactive: boolean;
}

export interface ElementUnitDto {
  code: number;
  unitaraname: string;
  unitlatname: string;
  notactive: boolean;
}

export interface PayElementSubElementsDto {
  id: string;
  subelementaraname: string;
  subelementlatname: string;
  elementid: string;
}

export interface PayElementTypeDto {
  code: number;
  typearaname: string;
  typelatname: string;
  notactive: boolean;
  notcomputed: boolean;
}

export interface PayContractHDto {
  id?: string;
  empid: string;
  trxdate: Date;
  startdate: Date;
  contractperiod: number;
  enddate: Date;
  contracttypecode: number;
  notes: string;
  testperiod: number;
  workingdayspermonth: number;
  workinghoursperday: number;
}

export interface PayContractFDto {
  id?: string;
  contractid: string;
  linenum: number;
  description: string;
  amount: number;
}

export interface PayContractTypeDto {
  code: number;
  contracttypearaname: string;
  contracttypelatname: string;
  notactive: boolean;
}

export interface SetupBranchDto {
  id?: string;
  branchid: string;
  calcworkingdaystype: number;
  workingdayspermonth: number;
  workinghoursperday: number;
  taxpersonalexemption: number;
  insuranceminsalary: number;
  insurancemaxsalary: number;
  insuranceemppercent: number;
  insurancecompanypercent: number;
}

export interface EmployeeDto {
  id?: string;
  empcode: number;
  empfullaraname: string;
  empfulllatname: string;
  gendercode: number;
  birthdate: Date;
  birthdate_h: string;
  mobilenum: string;
  emergencymobilenum: string;
  email: string;
  address: string;
  notes: string;
  idnumber: string;
  idstartdate: Date;
  idexpiredate: Date;
  passportno: string;
  passportexpiredate: Date;
  drivelicenseexpiredate: Date;
  userid: string;
  recruitingstartdate: Date;
  recruitingenddate: Date;
  lastleavedate: Date;
  lastreturndate: Date;
  bankaccountno: string;
  degreedate: Date;
  setuphrid: string;
  setupvacationid: string;
  setupevaluationid: string;
  emppicture: string;
}

export interface PayVariableElementsDto {
  id?: string;
  branchid: string;
  slipid: string;
  year: number;
  month: number;
  empid: string;
  elementid: string;
  subelementid: string;
  value: number;
  trxdate: string;
  notes: string;
  mysource: string;
}
export interface SimpleButton {
  text: string;        // نص الزر
  action: string;      // اسم الوظيفة
  color?: string;      // لون الزر
  icon?: string;       // أيقونة
  confirm?: boolean;   // هل يحتاج تأكيد
  confirmMessage?: string; // رسالة التأكيد
  confirmHeader?: string;  // عنوان التأكيد
}
export interface PayEmpStatusReasonDto {
  id?: string;
  code: string;
  araname: string;
  latname: string;
  notactive: boolean;
}
